const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/roadmaps/$roadmapId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { redirectToFirstViewOfType } from '@/lib/utils/roadmapping/redirectToFirstViewOfType';
export const Route = createFileRoute('/(app)/org/$org/roadmaps/$roadmapId/')({
  loader: async ({
    params: {
      org,
      roadmapId
    },
    context: {
      queryClient
    }
  }) => {
    await redirectToFirstViewOfType({
      org,
      roadmapId: Number(roadmapId),
      queryClient
    });
    return {};
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});